import React, { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import MenuCategory from '#app/components/MenuCategory/MenuCategory';
import { processOperations, updateMatchingComments } from './utils/updateOperation';
import { updateActiveType } from '#app/pages/IncomeAndExpenses/components/BaseOperationList/form/utils/updateActiveType';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import {
  setIncomeCategoryModalVisible,
  setSpendingCategoryModalVisible,
} from '#app/actions/category';
import { useActives } from '#app/pages/IncomeAndExpenses/components/ActivesContext';
import { ActiveConstants } from 'finhelper';
import {
  extractActiveIdsFromUpdateResponse,
  patchOperationsListCache,
} from '#app/helpers/operations/patchOperationsListCache';

const SearchCategory = ({ item, categoryText, customTypeId, types }) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const currencyId = useAppSelector((s) => s.interfaceComponents.currency?.id);

  const listKind = useMemo(
    () => (customTypeId === ActiveConstants.CUSTOM_INCOME ? 'incomes' : 'spendings'),
    [customTypeId]
  );

  const setIncomeCategoryModalVisibleFn = useCallback(
    () => dispatch(setIncomeCategoryModalVisible(true)),
    [dispatch]
  );
  const setSpendingCategoryModalVisibleFn = useCallback(
    () => dispatch(setSpendingCategoryModalVisible(true)),
    [dispatch]
  );

  const { preparedActives, setPreparedActives } = useActives();

  const handleCategoryClick = (selectedItem, isUnique) => {
    const typePayload = {
      id: item.id,
      type_id: selectedItem.id,
      custom_type_id: selectedItem.type_id,
      sign: selectedItem.sign ?? selectedItem.id,
      is_unique: !isUnique,
    };

    const { updatedData, commentToMatch } = processOperations(
      preparedActives,
      item,
      selectedItem,
      isUnique
    );

    const finalData = commentToMatch
      ? updateMatchingComments(updatedData, commentToMatch, selectedItem, isUnique)
      : updatedData;

    setPreparedActives(finalData);

    updateActiveType(typePayload, client, {
      onSuccess: (response) => {
        if (!client?.id || !currencyId) return;
        const activeIds = extractActiveIdsFromUpdateResponse(response, item.id);
        patchOperationsListCache(queryClient, listKind, client.id, currencyId, activeIds, {
          type_id: typePayload.type_id,
          custom_type_id: typePayload.custom_type_id,
          type_text: selectedItem.name,
          is_unique: typePayload.is_unique,
        });
      },
    });
  };

  return (
    <div className="flex items-center">
      <MenuCategory
        showUnique
        showAdd={() => {
          switch (customTypeId) {
            case ActiveConstants.CUSTOM_SPEND:
              setSpendingCategoryModalVisibleFn();
              break;
            case ActiveConstants.CUSTOM_INCOME:
              setIncomeCategoryModalVisibleFn();
              break;
          }
        }}
        id={item.id || Math.random().toString(36).substr(2, 9)}
        isUnique={item.is_unique}
        items={types}
        text={categoryText}
        handleClick={handleCategoryClick}
      />
    </div>
  );
};

export default SearchCategory;
